import React from 'react';
import { AppBar, Toolbar, Typography, IconButton } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import AddIcon from '@mui/icons-material/Add';

interface HeadingProps {
  title: string;
  optionalTitle?: string;
  onBackClick?: () => void;
  onAddClick?: () => void;
  vehicle?: string;
}

const Heading: React.FC<HeadingProps> = ({ 
  title, 
  onBackClick, 
  optionalTitle,
  onAddClick,
  vehicle
}) => {
  return (
    <div style={{ overflow: 'auto', backgroundColor: '#fff', borderRadius: '8px' }}>
      <AppBar position="static" color="transparent" elevation={0}>
        <Toolbar>
          {onBackClick && (
            <IconButton 
              edge="start" 
              aria-label="back" 
              onClick={onBackClick}
              sx={{
                mr: 2, 
                background: 'linear-gradient(135deg, #cc0000 0%, #2a0000 100%)',
                color: 'white',
                boxShadow: '0 4px 6px rgba(0,0,0,0.4)', 
                width: 40,
                height: 40,
                '&:hover': {
                  background: 'linear-gradient(135deg, #b30000 0%, #1a0000 100%)',
                },
                '& .MuiSvgIcon-root': {
                  fontSize: '1.5rem',
                }
              }}
            >
              <ArrowBackIcon />
            </IconButton>
          )}
          

          <Typography 
            variant="h6" 
            component="div" 
            style={{ 
              flexGrow: 1,
              color: '#121111',
              textAlign: !onBackClick ? 'center' : 'left'
            }}
          >
            {title}
          </Typography>
          
          {optionalTitle && (
            <Typography variant="subtitle1" component="div" style={{ marginLeft: 'auto', marginRight: '16px', color: '#68e0cf', fontWeight: 'bold' }}>
              {optionalTitle}
            </Typography>
          )}

          {vehicle && (
            <Typography 
              variant="subtitle1" 
              component="div" 
              sx={{ 
                ml: optionalTitle ? 0 : 'auto', 
                mr: onAddClick ? 2 : 0, 
                color: '#333', 
                fontWeight: 'bold',
                backgroundColor: '#ffffff',
                padding: '4px 12px',
                borderRadius: '4px',
                fontSize: '18px'
              }}
            >
              {vehicle}
            </Typography>
          )}
          
          {onAddClick && (
            <IconButton 
              onClick={onAddClick}
              sx={{
                background: 'linear-gradient(to bottom, #ff0000 0%, #4a0000 100%)',
                color: 'white',
                border: '2px solid black',
                width: 32,
                height: 32,
                boxShadow: '0 2px 4px rgba(0,0,0,0.4)',
                '&:hover': {
                  background: 'linear-gradient(to bottom, #cc0000 0%, #2a0000 100%)',
                }
              }}
            >
              <AddIcon sx={{ fontSize: '1.2rem' }} />
            </IconButton>
          )}
        </Toolbar>
      </AppBar>
    </div>
  );
};

export default Heading;